import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";

interface PGPKeyTableHeaderProps {
    children? : React.ReactNode
}

export const PGPKeyTableHeader = ({children} : PGPKeyTableHeaderProps ) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    return (
        <thead className="sticky-top">
        <tr className="text-nowrap">
            <th className="th-w-min">{children}</th>
            <th>{t("pgp-table-header.key-id")}</th>
            <th>{t("pgp-table-header.email")}</th>
            <th>{t("pgp-table-header.user-ids")}</th>
            <th>{t("pgp-table-header.fingerprint")}</th>
            <th>{t("pgp-table-header.sha256-fingerprint")}</th>
            <th>{t("pgp-table-header.creation-date")}</th>
            <th>{t("pgp-table-header.expiration-date")}</th>
            <th>{t("pgp-table-header.private-key-alias")}</th>
            <th>{t("pgp-table-header.valid-for-encryption")}</th>
            <th>{t("pgp-table-header.valid-for-signing")}</th>
            <th>{t("pgp-table-header.insertion-date")}</th>
            <th>{t("pgp-table-header.key-length")}</th>
            <th>{t("pgp-table-header.algorithm")}</th>
            <th>{t("pgp-table-header.master-key")}</th>
            <th>{t("pgp-table-header.parent-key-id")}</th>
            <th>{t("pgp-table-header.valid")}</th>
            <th>{t("pgp-table-header.failure-severity")}</th>
            <th>{t("pgp-table-header.failure-message")}</th>
            <th>{t("pgp-table-header.id")}</th>
        </tr>
        </thead>
    )
}
